import React from 'react'
import { BsCart4, } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
const Header = (props) => {

  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(`/${path}`, { state: props.cart });
  }


  return (
    <div className='w-full sticky top-0 z-50 flex flex-row items-center justify-between align-middle py-3.5 px-60 sm:px-3 shadow bg-white'>
    <div className=" WebsiteName italic animate-fade-down animate-delay-0 text-4xl sm:text-3xl bg-gradient-to-r from-cyan-600 to-sky-800 bg-clip-text text-transparent flex align-middle">
      YourGenie._.
    </div>

    <div className="flex flex-row align-middle gap-4 sm:gap-3">
    {/* <span className="animate-fade-down animate-delay-200 flex flex-row gap-0">
      <span className='border border-r-0 rounded-l-full flex items-center justify-center align-middle p-2 text-sky-600'><BsSearch/></span>
        <input type='text' placeholder='Search ...' 
        className='sm:w-24 w-44 products text-sm font-semibold border border-l-0 border-gray-200 focus:border-gray-200 flex flex-row focus:ring-0 focus:ring-gray-200 focus:outline-none  flex-nowrap items-start align-text-bottom italic justify-start rounded-r-full pr-2 sm:px-4 py-1 pb-1 text-gray-950  animate-fade-left animate-delay-0'></input>
      </span> */}
      <span className="animate-fade-down animate-delay-200">
        <button onClick={()=>handleNavigation('cartpage')} className="border border-gray-200 flex flex-row gap-1.5  hover:scale-75 transition-all flex-nowrap items-center align-middle justify-center rounded-full px-5 sm:px-4 py-1 pb-1 text-gray-950  animate-fade-left animate-delay-0">

          <BsCart4 className="bi bi-download  ms-1 text-sky-600 font-extrabold text-lg" />
          <span className="text-md products">{props.cart.length}</span>
        </button>
      </span>
      <span className="sm:hidden flex text-xl sm:text-lg  animate-fade-down animate-delay-500">
        <a href="mailto:shaikshafieluru@gmail.com" target="_blank" rel="noreferrer">
          <button className="hover:scale-75 transition-all animate-fade-down animate-delay-0">
            <i className=" bi bi-envelope-fill "></i>
          </button>
        </a>
      </span>
      <span className="sm:hidden flex text-xl sm:text-lg  animate-fade-down animate-delay-700">
        <a href="https://github.com/shafi099" target="_blank" rel="noreferrer">
          <button className="hover:scale-75 transition-all animate-fade-down animate-delay-500">
            <i className=" bi bi-github"></i>
          </button>
        </a>
      </span>
      <span className="sm:hidden flex text-xl sm:text-lg  animate-fade-down animate-delay-1000">
        <a
          href="https://www.linkedin.com/in/shaik-shafi-eluru/"
          target="_blank" rel="noreferrer"
        >
          <button className="hover:scale-75 transition-all animate-fade-down animate-delay-0">
            <i className=" bi bi-linkedin"></i>
          </button>
        </a>
      </span>
    </div>
  </div>
  )
}

export default Header